/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiMemberDtoCustomMemberFieldValueDto } from './WebApiMemberDtoCustomMemberFieldValueDto';
import {
    WebApiMemberDtoCustomMemberFieldValueDtoFromJSON,
    WebApiMemberDtoCustomMemberFieldValueDtoFromJSONTyped,
    WebApiMemberDtoCustomMemberFieldValueDtoToJSON,
} from './WebApiMemberDtoCustomMemberFieldValueDto';
import type { WebApiModelsEnumerationTypesEmailNotificationPreference } from './WebApiModelsEnumerationTypesEmailNotificationPreference';
import {
    WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSON,
    WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSONTyped,
    WebApiModelsEnumerationTypesEmailNotificationPreferenceToJSON,
} from './WebApiModelsEnumerationTypesEmailNotificationPreference';

/**
 * 
 * @export
 * @interface WebApiMemberDtoAddMemberFromPublicSiteDto
 */
export interface WebApiMemberDtoAddMemberFromPublicSiteDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberFromPublicSiteDto
     */
    companyUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberFromPublicSiteDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberFromPublicSiteDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberFromPublicSiteDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberFromPublicSiteDto
     */
    email2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberFromPublicSiteDto
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberFromPublicSiteDto
     */
    personalNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberFromPublicSiteDto
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberFromPublicSiteDto
     */
    postalArea?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberFromPublicSiteDto
     */
    adressRow2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberFromPublicSiteDto
     */
    adressRow3?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberFromPublicSiteDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberFromPublicSiteDto
     */
    phoneNumber2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberFromPublicSiteDto
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberFromPublicSiteDto
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberFromPublicSiteDto
     */
    company?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberFromPublicSiteDto
     */
    extra1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberFromPublicSiteDto
     */
    extra2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberFromPublicSiteDto
     */
    extra3?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberFromPublicSiteDto
     */
    webPage?: string | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesEmailNotificationPreference}
     * @memberof WebApiMemberDtoAddMemberFromPublicSiteDto
     */
    emailNotificationPreference?: WebApiModelsEnumerationTypesEmailNotificationPreference;
    /**
     * 
     * @type {Array<WebApiMemberDtoCustomMemberFieldValueDto>}
     * @memberof WebApiMemberDtoAddMemberFromPublicSiteDto
     */
    customFields?: Array<WebApiMemberDtoCustomMemberFieldValueDto> | null;
    /**
     * 
     * @type {Date}
     * @memberof WebApiMemberDtoAddMemberFromPublicSiteDto
     */
    dateJoined?: Date;
    /**
     * 
     * @type {Array<number>}
     * @memberof WebApiMemberDtoAddMemberFromPublicSiteDto
     */
    memberProducts?: Array<number> | null;
}

/**
 * Check if a given object implements the WebApiMemberDtoAddMemberFromPublicSiteDto interface.
 */
export function instanceOfWebApiMemberDtoAddMemberFromPublicSiteDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiMemberDtoAddMemberFromPublicSiteDtoFromJSON(json: any): WebApiMemberDtoAddMemberFromPublicSiteDto {
    return WebApiMemberDtoAddMemberFromPublicSiteDtoFromJSONTyped(json, false);
}

export function WebApiMemberDtoAddMemberFromPublicSiteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiMemberDtoAddMemberFromPublicSiteDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyUrl': !exists(json, 'companyUrl') ? undefined : json['companyUrl'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'email2': !exists(json, 'email2') ? undefined : json['email2'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'personalNumber': !exists(json, 'personalNumber') ? undefined : json['personalNumber'],
        'postalCode': !exists(json, 'postalCode') ? undefined : json['postalCode'],
        'postalArea': !exists(json, 'postalArea') ? undefined : json['postalArea'],
        'adressRow2': !exists(json, 'adressRow2') ? undefined : json['adressRow2'],
        'adressRow3': !exists(json, 'adressRow3') ? undefined : json['adressRow3'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'phoneNumber2': !exists(json, 'phoneNumber2') ? undefined : json['phoneNumber2'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'company': !exists(json, 'company') ? undefined : json['company'],
        'extra1': !exists(json, 'extra1') ? undefined : json['extra1'],
        'extra2': !exists(json, 'extra2') ? undefined : json['extra2'],
        'extra3': !exists(json, 'extra3') ? undefined : json['extra3'],
        'webPage': !exists(json, 'webPage') ? undefined : json['webPage'],
        'emailNotificationPreference': !exists(json, 'emailNotificationPreference') ? undefined : WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSON(json['emailNotificationPreference']),
        'customFields': !exists(json, 'customFields') ? undefined : (json['customFields'] === null ? null : (json['customFields'] as Array<any>).map(WebApiMemberDtoCustomMemberFieldValueDtoFromJSON)),
        'dateJoined': !exists(json, 'dateJoined') ? undefined : (new Date(json['dateJoined'])),
        'memberProducts': !exists(json, 'memberProducts') ? undefined : json['memberProducts'],
    };
}

export function WebApiMemberDtoAddMemberFromPublicSiteDtoToJSON(value?: WebApiMemberDtoAddMemberFromPublicSiteDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'companyUrl': value.companyUrl,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'email': value.email,
        'email2': value.email2,
        'address': value.address,
        'personalNumber': value.personalNumber,
        'postalCode': value.postalCode,
        'postalArea': value.postalArea,
        'adressRow2': value.adressRow2,
        'adressRow3': value.adressRow3,
        'phoneNumber': value.phoneNumber,
        'phoneNumber2': value.phoneNumber2,
        'title': value.title,
        'country': value.country,
        'company': value.company,
        'extra1': value.extra1,
        'extra2': value.extra2,
        'extra3': value.extra3,
        'webPage': value.webPage,
        'emailNotificationPreference': WebApiModelsEnumerationTypesEmailNotificationPreferenceToJSON(value.emailNotificationPreference),
        'customFields': value.customFields === undefined ? undefined : (value.customFields === null ? null : (value.customFields as Array<any>).map(WebApiMemberDtoCustomMemberFieldValueDtoToJSON)),
        'dateJoined': value.dateJoined === undefined ? undefined : (value.dateJoined.toISOString().substr(0,10)),
        'memberProducts': value.memberProducts,
    };
}

